module.exports = __webpack_public_path__ + "img/T5-A-rc_4.1bf47db3.png";